import React from 'react';
import { CalendarIcon, AlertTriangleIcon, TrendingUpIcon } from 'lucide-react';
export function TransitionPlan() {
  const schedule = [{
    day: 1,
    anifit: 10,
    old: 90
  }, {
    day: 2,
    anifit: 20,
    old: 80
  }, {
    day: 3,
    anifit: 30,
    old: 70
  }, {
    day: 4,
    anifit: 40,
    old: 60
  }, {
    day: 5,
    anifit: 50,
    old: 50
  }, {
    day: 6,
    anifit: 60,
    old: 40
  }, {
    day: 7,
    anifit: 70,
    old: 30
  }, {
    day: 8,
    anifit: 80,
    old: 20
  }, {
    day: 9,
    anifit: 90,
    old: 10
  }, {
    day: 10,
    anifit: 100,
    old: 0
  }];
  return <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-orange-50 to-white" data-id="element-305">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-306">
        <div className="text-center mb-8 sm:mb-12" data-id="element-307">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[rgb(var(--color-neutral-900))] mb-3 sm:mb-4" data-id="element-308">
            De Veilige Overstap: Zo Doet u het Goed
          </h2>
          <p className="text-base sm:text-xl text-[rgb(var(--color-neutral-800))] max-w-3xl mx-auto leading-relaxed" data-id="element-309">
            Je kunt niet van de ene op de andere dag overschakelen naar Anifit.
            Het lichaam heeft tijd nodig om te ontgiften en aan te passen.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12 mb-6 sm:mb-8" data-id="element-310">
          <div className="flex flex-col sm:flex-row items-center gap-4 mb-6 sm:mb-8" data-id="element-311">
            <CalendarIcon className="w-10 h-10 sm:w-12 sm:h-12 text-[rgb(var(--color-primary))]" data-id="element-312" />
            <div className="text-center sm:text-left" data-id="element-313">
              <h3 className="text-xl sm:text-2xl font-bold text-[rgb(var(--color-neutral-900))]" data-id="element-314">
                10-Dagen Overstapplan
              </h3>
              <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))]" data-id="element-315">
                Geleidelijk en veilig overschakelen
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mb-6 sm:mb-8" data-id="element-316">
            {schedule.map((day, index) => <div key={index} className="text-center" data-id="element-317">
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border-2 border-green-200 mb-2" data-id="element-318">
                  <p className="font-bold text-[rgb(var(--color-neutral-900))] mb-3" data-id="element-319">
                    Dag {day.day}
                  </p>
                  <div className="h-24 bg-gray-200 rounded-lg overflow-hidden relative" data-id="element-320">
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-500 to-emerald-400 transition-all duration-500" style={{
                  height: `${day.anifit}%`
                }} data-id="element-321"></div>
                  </div>
                  <div className="mt-3 space-y-1" data-id="element-322">
                    <p className="text-sm font-semibold text-green-700" data-id="element-323">
                      {day.anifit}% Anifit
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-324">{day.old}% Oud voer</p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 sm:p-6 rounded-lg" data-id="element-325">
            <div className="flex flex-col sm:flex-row items-start gap-4" data-id="element-326">
              <TrendingUpIcon className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600 flex-shrink-0" data-id="element-327" />
              <div data-id="element-328">
                <h4 className="font-bold text-base sm:text-lg text-[rgb(var(--color-neutral-900))] mb-2" data-id="element-329">
                  Belangrijk te weten:
                </h4>
                <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))] leading-relaxed" data-id="element-330">
                  Elke paar dagen verhoog je het percentage Anifit met ongeveer
                  10%, totdat je na 10 dagen op 100% Anifit zit. Hoe langer je
                  hond slecht voer heeft gehad en hoe ouder hij is, hoe
                  voorzichtiger je dit proces moet doorlopen.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-amber-100 to-orange-100 border-2 border-amber-400 rounded-2xl p-6 sm:p-8 lg:p-12 shadow-xl" data-id="element-331">
          <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6" data-id="element-332">
            <AlertTriangleIcon className="w-12 h-12 sm:w-16 sm:h-16 text-amber-600 flex-shrink-0" data-id="element-333" />
            <div data-id="element-334">
              <h3 className="text-xl sm:text-2xl font-bold text-[rgb(var(--color-neutral-900))] mb-3 sm:mb-4" data-id="element-335">
                Normaal tijdens de overstap
              </h3>
              <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] leading-relaxed mb-4" data-id="element-336">
                Na jarenlange voeding met conserveringsmiddelen, toevoegingen en
                vulstoffen heeft het lichaam van je hond veel afvalstoffen
                opgeslagen. Wanneer je overschakelt naar natuurlijke voeding,
                gaat het lichaam deze gifstoffen uitscheiden.
              </p>
              <div className="bg-white/60 p-4 rounded-lg" data-id="element-337">
                <p className="font-semibold text-[rgb(var(--color-neutral-900))] mb-2" data-id="element-338">
                  Mogelijke ontgiftingsverschijnselen:
                </p>
                <ul className="space-y-1 text-sm sm:text-base text-[rgb(var(--color-neutral-800))]" data-id="element-339">
                  <li data-id="element-340">• Lichte diarree</li>
                  <li data-id="element-341">• Winderigheid</li>
                  <li data-id="element-342">• Iets sterkere lichaamsgeur</li>
                </ul>
                <p className="mt-4 font-bold text-green-700 text-sm sm:text-base" data-id="element-343">
                  Dit is een teken dat het lichaam aan het werk is! Blijf het
                  proces volgen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}